import React from 'react'
import { Row } from '@ztechapps/webui.data-tools'
import { formatDate, formatMoney } from '@ztechapps/common.utils'
import { RadioInput } from '@ztechapps/webui.input'
import { HorizontalStack } from '@ztechapps/webui.util'
import { useCheckoutContext } from '../../../index'

export const ListRow = (props) => {
  const context = useCheckoutContext()
  const [shippingOptions] = context.shippingOptions

  const { shippingAmount, deliveryDays, estimatedDeliveryDate, serviceType, carrierName, _id } = props

  return (
    <Row {...props}>
      <td>
        <HorizontalStack>
          <RadioInput
            label={carrierName}
            name={'shippingRate'}
            type={'radio'}
            readOnly
            checked={shippingOptions?.carrierRate?._id === _id}
            className={'me-2'}
          />
        </HorizontalStack>
      </td>
      <td>{serviceType}</td>
      <td>{deliveryDays ?? '--'}</td>
      <td>{!estimatedDeliveryDate ? '--' : formatDate(estimatedDeliveryDate)}</td>
      <td>{formatMoney(shippingAmount)}</td>
    </Row>
  )
}
